
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

import jQuery from 'jquery';
import Swal from 'sweetalert2';
import select2 from 'select2';
import 'select2/dist/css/select2.css';
import "/node_modules/select2/dist/css/select2.css";
select2();

jQuery()
window.$ = window.jQuery = jQuery;

window.select2 = select2;
select2();
window.Swal = Swal;

// window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
/*
const app = new Vue({
    el: '#app'
});
*/
//const Swal = window.Swal = require('sweetalert2')

// Mobilmenyn: Bulmas navbar-burger togglar inte sig själv. CSS-konventionen
// finns redan i bulma-admin.scss (#touchMenu.is-active { display: block }) —
// det var bara den här kopplingen som aldrig skrevs.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.navbar-burger').forEach((burger) => {
        const target = document.getElementById(burger.dataset.target);
        if (!target) return;

        burger.addEventListener('click', () => {
            burger.classList.toggle('is-active');
            target.classList.toggle('is-active');
            burger.setAttribute('aria-expanded', burger.classList.contains('is-active') ? 'true' : 'false');
        });
    });
});
